import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './Components/NavBar'
import LandingPage from './Pages/LandingPage'
import "swiper/css";
import Footer from './Components/Footer';
import ContactUsPage from './Pages/ContactUsPage';
import AboutUsPage from './Pages/AboutUsPage';
import ProductsPage from './Pages/ProductsPage';
import SeperateProductPage from './Pages/SeperateProductPage';
import TextilePage from './Pages/TextilePage';
import { FaBed, FaCarrot, FaLeaf, FaRegLemon, FaSeedling } from 'react-icons/fa';

// Per ProductsPage.js (context), productCategories:
const productCategories = [
  {
    icon: <FaLeaf className="text-4xl text-lime-600" />, // Saree
    title: "Sarees",
    desc: "Elegant traditional and designer sarees with exquisite craftsmanship.",
    highlights: [
      "Cotton Sarees",
      "Silk Sarees",
      "Georgette Sarees",
      "Banarasi Sarees",
      "Embroidered Sarees",
      "Printed Sarees",
      "Party Wear Sarees",
      "Casual Sarees",
    ],
    extra: "Each saree is carefully sourced for quality, variety, and comfort.",
    img: "/Products/sarees.jpg",
    path: "/products/sarees",
  },
  // {
  //   icon: <FaRegLemon className="text-4xl text-lime-600" />, // Blouse
  //   title: "Blouses",
  //   desc: "Designer and ready-made blouses to complement every saree style.",
  //   highlights: [
  //     "Cotton Blouses",
  //     "Silk Blouses",
  //     "Embroidered Blouses",
  //     "Readymade Blouses",
  //     "Custom Tailored Blouses",
  //     "Sleeveless & Full Sleeve Options",
  //   ],
  //   extra: "Premium fabric quality, comfortable fit, and modern patterns.",
  //   img: "/Products/blouse.jpg",
  //   path: "/products/blouses",
  // },
  {
    icon: <FaSeedling className="text-4xl text-lime-600" />, // Lady Suit
    title: "Ladies Suits",
    desc: "Chic and comfortable ladies suits for formal and casual occasions.",
    highlights: [
      "Punjabi Suits",
      "Salwar Kameez",
      "Churidar Suits",
      "Anarkali Suits",
      "Designer Partywear",
      "Unstitched Dress Materials",
    ],
    extra: "Wide range of colors, fabrics, and designs for every preference.",
    img: "/Products/suit.jpg",
    path: "/products/ladies-suits",
  },
  {
    icon: <FaCarrot className="text-4xl text-lime-600" />, // Kurtis
    title: "Kurtis",
    desc: "Trendy kurtis in modern and ethnic styles for everyday elegance.",
    highlights: [
      "Cotton Kurtis",
      "Anarkali Kurtis",
      "Long & Short Kurtis",
      "Printed Kurtis",
      "Embroidered Kurtis",
      "Designer Kurtis",
    ],
    extra: "Perfect for daily wear, work, or festive occasions.",
    img: "/Products/kurti.jpg",
    path: "/products/kurtis",
  },
  {
    icon: <FaLeaf className="text-4xl text-lime-600" />, // Shawl
    title: "Shawls",
    desc: "Luxurious shawls to add warmth and sophistication to any outfit.",
    highlights: [
      "Woolen Shawls",
      "Pashmina Shawls",
      "Printed Shawls",
      "Embroidered Shawls",
      "Designer Wraps",
    ],
    extra: "Soft, elegant, and perfect for gifting or personal use.",
    img: "/Products/shawl.jpg",
    path: "/products/shawls",
  },
  {
    icon: <FaBed className="text-4xl text-lime-600" />, // Bedsheets
    title: "Bedsheets",
    desc: "Premium bedsheets in a variety of fabrics, prints, and sizes for comfortable living.",
    highlights: [
      "100% Cotton Bedsheets",
      "Satin & Percale Options",
      "Single, Double, Queen & King Sizes",
      "Printed & Embroidered Styles",
      "Custom Branding",
      "Hospitality Bulk Orders",
    ],
    extra: "High thread count, colorfastness, and export-quality packaging available.",
    img: "/Products/bedsheets.jpg",
    path: "/products/bedsheets",
  },
  {
    icon: <FaCarrot className="text-4xl text-lime-600" />, // Sport T Shirt (reusing a veggie icon)
    title: "Sport T Shirt",
    desc: "Performance and comfort driven sport T-shirts for every activity, made with moisture-wicking technical fabrics.",
    highlights: [
      "Polyester Dry-Fit T Shirts",
      "Customizable with Logos & Branding",
      "Unisex, Men’s & Women’s Styles",
      "Variety of Colours & Sizes",
      "Sublimation & Screen Print Options",
      "Perfect for Teams, Events, and Corporate Gifting",
    ],
    extra: "Quick-dry, breathable materials. Bulk and made-to-order available for schools, events, & clubs.",
    img: "/Products/1.png",
    path: "/products/sport-tshirt",
  },
];

const App = () => {
  return (
    <>
      <Navbar/>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/textile" element={<TextilePage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />

          {/* Seperate product routes */}
          {productCategories.map((prod) => (
            <Route
              key={prod.path}
              path={prod.path}
              element={
                <SeperateProductPage
                  title={prod.title}
                  desc={prod.desc}
                  highlights={prod.highlights}
                  extra={prod.extra}
                  img={prod.img}
                />
              }
            />
          ))}
        </Routes>
      </Router>
      <Footer />
    </>
  )
}

export default App